import React, { ReactNode } from 'react'
import cx from 'classnames'
import styleProvider from '@quotatisgroup/uikit-public.style-provider'

import './text.scss'

export type TextProps = {
  children?: ReactNode | string
  className?: string
  classes?: string
  size?: 'xs' | 'small'
  caption?: boolean
  bold?: boolean
}

function TextComponent({
  children,
  classes,
  className,
  size,
  caption = false,
  bold = false,
}: TextProps) {
  return (
    <p
      className={cx(
        classes,
        {
          [size]: size,
          caption,
          bold,
        },
        className,
      )}
    >
      {children}
    </p>
  )
}

export const Text = styleProvider(TextComponent)
